module.exports = __webpack_public_path__ + "img/heart_15_bj.7981ad3b.png";